import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import languageService from '../../services/language';
import './index.css';

const SCROLL = 100;

export default class BigImageSlider extends Component {
  state = {
    legendVisible: true,
    mounted: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll.bind(this));

    this.setState({ mounted: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll.bind(this));

    this.setState({ mounted: false });
  }

  onScroll(event) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

    if (this.state.mounted && scrollTop > SCROLL && this.state.legendVisible === true) {
      this.setState({
        legendVisible: false
      });
    } else if (this.state.mounted && scrollTop <= SCROLL && this.state.legendVisible === false) {
      this.setState({
        legendVisible: true
      });
    }
  }

  renderContent(images) {
    const carouselProps = {
      axis: "horizontal",
      showThumbs: false,
      showStatus: false,
      showArrows: false,
      emulateTouch: true,
      autoPlay: false,
      infiniteLoop: true,
      interval: 10000,
      showIndicators: (images || []).length > 1
    };

    const renderedImages = images.map((image, index) => {
      const renderedText = !image.text ? null : (
        <div className="text">{image.text[languageService.language] || ''}</div>
      );

      const renderedSecondaryTextClassNames = image.secondaryTextSmall ? 'secondaryText secondaryText--small' : 'secondaryText';

      const renderedSecondaryText = !image.secondaryText ? null : (
        <div className={renderedSecondaryTextClassNames}>{image.secondaryText[languageService.language] || ''}</div>
      );

      let legendStyle = {
        opacity: 1,
        transitionDuration: '0.4s'
      };

      if (!this.state.legendVisible) {
        legendStyle = {
          opacity: 0,
          transitionDuration: '0.4s'
        };
      }

      const legend = (
        <div className="legend">
          <div style={legendStyle}>
            {renderedText}
            {renderedSecondaryText}
          </div>
        </div>
      );

      return (
        <div className="image" style={{backgroundImage: `url('${image.imageUrl}')`}} key={`bigimageslider-${index}`}>
          {legend}
        </div>
      );
    });

    return (
      <Carousel {...carouselProps}>
        {renderedImages}
      </Carousel>
    );
  }

  render() {
    let rendered = null;

    if (this.props && this.props.sliderImages) {
      rendered = this.renderContent(this.props.sliderImages);
    }

    return (
      <div className="comp-bigImageSlider">
        {rendered}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bigImageSlider/index.js